// Shared display helpers and constants
export const STAGES = ["Case Assessment", "Pre-Trial", "Pre-Discovery", "Discovery", "Trial", "Judgment"];

export function stageIndex(s) {
  return STAGES.indexOf(s);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return "—";
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / (1000 * 60 * 60 * 24));
}

export function fmtMoney(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
}

export const strengthColor = {
  strong: "#6B8E23",
  moderate: "#C5A059",
  weak: "#B91C1C",
  unknown: "#6b7280",
};

export const statusTone = {
  Active: "#6B8E23", Approved: "#C5A059", Proposed: "#8b8b8b", Waiting: "#D97706",
  Completed: "#4b7bab", Cancelled: "#6b7280",
};

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

export function humanName(name) {
  if (!name) return name || "";
  return String(name).trim().toLowerCase().replace(/(^|[\s\-'.])([a-z])/g, (_, sep, ch) => sep + ch.toUpperCase());
}
